export default function ivrService($http, RESOURCES) {
  'use strict';
    var URL = RESOURCES.MERCHANT + '/ivr'; //to change according to API endpoint
    var DEFAULT_PAGE = 0;
    var DEFAULT_PAGE_SIZE = 30;
  
    function fetch(page, max) {
      return $http.get(URL + '?page=' + (page || DEFAULT_PAGE) + '&max=' + (max || DEFAULT_PAGE_SIZE));
    }
  
    function findById(id) {
      return $http.get(URL + '?ids=' + id);
    }
  
    function enable(merchantIds) {
      return $http.post(URL, {enabled: true, merchantIds: merchantIds});
    }
  
    function disable(merchantIds) {
      return $http.post(URL, {enabled: false, merchantIds: merchantIds});
    }
  
    return {
      fetch: fetch,
      findById: findById,
      enable: enable,
      disable: disable,
    };
  }
  


// WEBPACK FOOTER //
// ./src/app/merchants/ivr/ivr.service.js